import { CAPTURE_FULL, coordEq, getTile } from "@dailywars/core/engine";
import type { Coord, GameState, PlayerId, UnitKind } from "@dailywars/core/engine";

import type { StoreState } from "#/game/store/types";

import { TUTORIAL_COORDS } from "./tutorialGame";

export const COORDS = TUTORIAL_COORDS;

export function ownUnitAt(state: GameState, target: { coord: Coord; kind: UnitKind }): boolean {
  return state.units.some(
    (u) => u.owner === "p1" && u.kind === target.kind && coordEq(u.pos, target.coord),
  );
}

export function isUnitSelected(
  store: StoreState,
  { kind, coord }: { kind: UnitKind; coord: Coord },
): boolean {
  const { selection, localState } = store;
  if (selection.mode !== "unit") return false;
  const unit = localState.units.find((u) => u.id === selection.unitId);
  return Boolean(unit && unit.owner === "p1" && unit.kind === kind && coordEq(unit.pos, coord));
}

export function enemyUnit(state: GameState) {
  return state.units.find((u) => u.owner === "p2");
}

export function isIdle(store: StoreState): boolean {
  return !store.animation && !store.aiPlayback && !store.isSubmitting;
}

export function captureRemainingAt(state: GameState, coord: Coord): number {
  return getTile(state, coord).capturePoints ?? CAPTURE_FULL;
}

export function tileOwnerAt(state: GameState, coord: Coord): PlayerId | "neutral" | undefined {
  const tile = getTile(state, coord);
  if (!("owner" in tile)) return undefined;
  return tile.owner;
}
